var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"point-analysis-item"},[_vm._t("icon"),(_vm.title)?_c('div',{staticClass:"title"},[_vm._v(_vm._s(_vm.title))]):_vm._e(),(_vm.desc)?_c('div',{staticClass:"desc"},[_vm._v(_vm._s(_vm.desc))]):_vm._e()],2)
}
var staticRenderFns = []

export { render, staticRenderFns }